// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none{display:none}.sf-header-navigation-item__link{display:flex}.sf-header-navigation-item__link .sf-icon{display:inline-flex;margin:0 var(--spacer-xs)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
